import React, { useEffect, useState } from 'react';
import { Row } from 'reactstrap';
import Loader from 'react-loader-spinner';

const WithLoader = ({ action, children }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    action(() => setIsLoaded(true));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    isLoaded ? children : (
      <Row style={{ justifyContent: 'center' }}>
        <Loader type="TailSpin" color="#00BFFF" />
      </Row>
    )
  );
};

export default WithLoader;